mutation PurchaseOrderPromoteDeliveryAddress(
  $input: PurchaseOrderPromoteDeliveryAddressInput!
) {
  purchaseOrderPromoteDeliveryAddress(input: $input) {
    purchaseOrder {
      deliveryAddressId
      deliveryAddressAlias
      deliveryAddressLine1
      deliveryAddressLine2
      deliveryCityName
      deliveryCountryId
      deliveryStateRegionId
      deliveryPostalCode
      deliveryEmailAddress
      deliveryTelephoneNumber
      _isPromoteAddressAllowed
    }
  }
}
